/**
 *
 * Form
 *
 */

import React, { Fragment } from "react"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { Link } from "react-router-dom"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import {
  makeSelectUserSASwitch,
  makeSelectOptions,
  makeSelectOptionsLoading,
  makeSelectSaveLoading,
  makeSelectCurrentCompany,
  makeSelectCurrentCompanyLoading,
  makeSelectDeleteLoading,
  makeSelectUsersLoading,
  makeSelectUsers,
  makeSelectCurrentUsers,
  makeSelectValidateVismaPeopleInfoLoading,
  makeSelectValidateVismaPeopleInfo,
  makeSelectValidateVismaPeopleInfoRequested,
  makeSelectValidateVismaPeopleStructureRequested,
  makeSelectValidateVismaPeopleStructureLoading,
  makeSelectValidateVismaPeopleStructure,
  makeSelectValidateVismaPeopleStructureFeedback,
} from "./selectors"

import {
  getCompaniesInfoWatcher,
  saveCompanyWatcher,
  getCompanyWatcher,
  deleteCompanyWatcher,
  statusCompanyWatcher,
  usersCompanyWatcher,
  usersSASwitchWatcher,
  getCompanyUsersWatcher,
  deleteUserWatcher,
  validateVismaPeopleInfoWatcher,
  validateVismaPeopleStructureWatcher,
  updateValidateVismaPeopleRequested,
  updateValidateVismaPeopleStructureRequested,
  resetCompaniesInfo,
  resetVismaPeopleValidations,
  resetVismaPeopleStructureValidations,
} from "./actions"
import reducer from "./reducer"
import saga from "./saga"
import Layout from "components/Layout"
import {
  toggleSyncSwitch,
  validateSyncCredentials,
  editStructureIds,
  validateUrlPerformance
} from '../../../../services/logs';

import ModalCreateUser from "components/ModalCreateUser"
import {
  Menu,
  Dropdown,
  Button,
  Tabs,
  Input,
  Select,
  Divider,
  Switch,
  Spin,
  Tooltip,
  message,
  DatePicker,
  InputNumber,
  Popover,
} from "antd"
import { EllipsisOutlined, EyeInvisibleOutlined, EyeTwoTone, LeftOutlined } from "@ant-design/icons"
import { Form } from "@ant-design/compatible"

import ButtonsFooter from "components/ButtonsFooter"
import AdministratorList from "components/AdministratorList"
import CompanyActivity from "components/CompanyActivity"
import ModalDeleteSimple from "components/ModalDeleteSimple"
import { get, isArray, isEqual, isNull, times } from "lodash"
import ModalCustom from "components/ModalCustom"
import alertSvg from "images/alert.svg"
import checkIconCircle from "images/check-icon-circle.svg"
import companyIcon from "images/company-icon.svg"
import xIconCircle from "images/x-icon-circle.svg"
import warningIconCircle from "images/warning-icon-circle.svg"
import { ROLE_COMPANY_SUPER_ADMIN } from "utils/constants"
import moment from "moment"
import "@ant-design/compatible/assets/index.css"
import "./index.less"
import Checkbox from "antd/lib/checkbox/Checkbox"

const { TabPane } = Tabs
const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
const defaultData = {
  name: "",
  sectorGlobal: undefined,
  size: undefined,
  collaborator: undefined,
  country: undefined,
  performance_subdomain: "",
  id_license: 2,
  active: 1,
  trial_max_collaborators: 100,
  trial_start_date: null,
  trial_duration: 30,
  account_manager: [],
  support_channel: "PE",
  demo: false,
  hubspot_company_id: null,
  top_three_box_enable: true,
  pdas_ia_enable :true,
  visma_people_sync: false
}
export class FormCompany extends React.Component {
  is_new = window.location.href.indexOf("/companies/new") > -1
  set_default_module = !!this.is_new
  state = {
    companyId: parseInt(this.props.match.params.id),
    modalCreateUser: false,
    tab: 1,
    modalAdminTitle: "Crear usuario",
    userSelected: {},
    formData: JSON.parse(JSON.stringify(defaultData)),
    formDataBackup: JSON.parse(JSON.stringify(defaultData)),
    modalSwitchCompany: false,
    modalAdminDelete: false,
    modalCompanyDelete: false,
    modalChangeLicense: false,
    showError: false,
    currentAccountManager: "",
    modalEnableVismaPeopleSync: false,
    modalDisableVismaPeopleSync: false,
    validateButtonDisabled: true,
    disableFields: true,
    vismaPeopleData: '',
    vismaPeopleDataStructure: '',
    urlPerformanceError: null
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      (!isEqual(nextProps.current_company, this.props.current_company) &&
        nextProps.current_company.name) ||
      (!nextProps.save_loading &&
        this.props.save_loading &&
        !isEqual(nextProps.current_company, this.props.current_company))
    ) {
      let current = nextProps.current_company
      let setData = {
        name: current.name,
        sectorGlobal: current.sectorGlobal,
        size: current.size,
        collaborator: current.collaborator,
        country: current.country,
        performance_subdomain: current.performance_subdomain || "",
        id_license: current.id_license,
        active: current.active,
        disabled: current.disabled || false,
        trial_max_collaborators: current.trial_max_collaborators,
        trial_start_date: moment(current.trial_start_date),
        trial_duration: current.trial_duration,
        account_manager: current.account_manager,
        support_channel: current.support_channel || "PE",
        performance_support_channel: current.performance_support_channel || null,
        demo: current.demo,
        hubspot_company_id: current.hubspot_company_id,
        top_three_box_enable: current.top_three_box_enable,
        pdas_ia_enable : current.pdas_ia_enable ,
        visma_people_sync_request: current.visma_people_sync_request,
        visma_people_user: current.visma_people_user,
        visma_people_password: current.visma_people_password,
        visma_people_tenant: current.visma_people_tenant,
        visma_people_id_geographic_location: current.visma_people_id_geographic_location,
        visma_people_id_herarquical_category: current.visma_people_id_herarquical_category,
        visma_people_id_position: current.visma_people_id_position,
        visma_people_available: current.visma_people_available,
        visma_people_sync_enabled: current.visma_people_sync_enabled,
        visma_people_new_company: current.visma_people_new_company
      }
      this.setState({
        formData: JSON.parse(JSON.stringify(setData)),
        formDataBackup: JSON.parse(JSON.stringify(setData)),
      })
    }
  }

  componentDidMount() {
    if (!this.is_new) {
      this.props.getCompany({ company_id: this.state.companyId })
      this.props.getUsers({ company_id: this.state.companyId })
      this.props.resetVismaPeopleValidations()
    } else {
      this.props.resetCompaniesInfo()
      this.props.getCompaniesInfo()
    }
  }

  setFormData = (key, data) => {
    let formData = this.state.formData
    formData[key] = data
    this.setState({
      formData,
    })
  }

  handleSave = () => {
    let { formData, formDataBackup } = this.state

    if (formDataBackup.id_license === 4 && formData.id_license !== 4)
      this.setState({ modalChangeLicense: true })
    else this.pressSave()

    if(!this.props.current_company.visma_people_sync_request) {
      try {
        const response = editStructureIds();
      } catch (error) {
        console.error('Error:', error);
      }
    }
   
  }

  pressSave = () => {
    this.setState({ modalChangeLicense: false })
    let { formData, companyId } = this.state
    formData = JSON.parse(JSON.stringify(formData))
    formData.company_id = companyId
    formData.trial_start_date = moment(formData.trial_start_date).isValid()
      ? moment(formData.trial_start_date).format("YYYY-MM-DD")
      : null
    /** Visma people data */
    if (formData.visma_people_sync_request) {
      formData.visma_people_tenant_name = this.props.validateVismaPeopleInfo.company
      formData.visma_people_geographic_location_name = this.props.current_company.visma_people_id_geographic_location ? this.props.current_company.visma_people_id_geographic_location : this.props.validateVismaPeopleStructure.data.geographic_location.name
      formData.visma_people_herarquical_category_name = this.props.current_company.visma_people_id_herarquical_category ? this.props.current_company.visma_people_id_herarquical_category : this.props.validateVismaPeopleStructure.data.herarquical_category.name
      formData.visma_people_position_name = this.props.current_company.visma_people_id_position ? this.props.current_company.visma_people_id_position : this.props.validateVismaPeopleStructure.data.position.name
    }
    if (formData.id_license !== 1 && !formData.trial_start_date) {
      delete formData.trial_start_date
    }
    this.props.saveCompany(formData)
    this.setState({ showError: false })
  }

  checkLoading = () => {
    const { options_loading, current_company_loading } = this.props
    if (!this.is_new) {
      return options_loading && current_company_loading
    }
    return options_loading
  }
  checkUsersLoading = () => {
    const {options_loading,current_users_loading } = this.props
    if (!this.is_new) {
      return options_loading && current_users_loading
    }
    return options_loading
  }

  setStateFrom = (name, value) => {
    this.setState({
      [name]: value,
    })
  }

  setToInitialDay = (t) => {
    return t.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
  }

  handleValidateVismaPeopleInfo = () => {
    const { visma_people_user, visma_people_password, visma_people_tenant } = this.state.formData

    this.setState({ vismaPeopleData: `${visma_people_user}${visma_people_password}${visma_people_tenant}` })

    this.props.validateVismaPeopleInfoWatcher({
      visma_people_user,
      visma_people_password,
      visma_people_tenant
    })

    try {
      const response = validateSyncCredentials();
    } catch (error) {
      console.error('Error:', error);
    }
  }

  checkDisabledValidateButton = () => {
    if(!this.props.validateVismaPeopleInfoRequested) {
      return false
    }

    return true
  }

  showStructuresFeedback = () => {
    if(this.props.validateVismaPeopleStructureFeedback) {
      return Object.entries(this.props.validateVismaPeopleStructureFeedback).map(([_, value]) => {
        if (value.success) {
          return <p className="warning-message"><img src={warningIconCircle} /> {value.message}</p>
        } else {
          return <p className="error-message"><img src={xIconCircle} /> {value.message}</p>
        }
      });
    }
  }

  handleValidateVismaPeopleStructure = () => {
    const { 
      visma_people_user,
      visma_people_password,
      visma_people_tenant,
      visma_people_id_geographic_location, 
      visma_people_id_herarquical_category, 
      visma_people_id_position 
    } = this.state.formData

    this.props.validateVismaPeopleStructureWatcher({
      visma_people_user,
      visma_people_password,
      visma_people_tenant,
      visma_people_id_geographic_location,
      visma_people_id_herarquical_category,
      visma_people_id_position
    })

    this.setState({
      vismaPeopleDataStructure: `${visma_people_id_geographic_location}${visma_people_id_herarquical_category}${visma_people_id_position}`
    })
  
  }

  showFieldsFeedback = () => {

    let infoSuccess = get(this.props.validateVismaPeopleInfo, "success", null)

    if(!isNull(infoSuccess) && this.props.validateVismaPeopleInfo.success) {
      return ( 
        <div>
          <p className="success-message"><img src={checkIconCircle} /> Usuario, contraseña y tenant validados.</p>
          <p className="default-message"><img src={companyIcon} /> Empresa identificada: <b>{this.props.validateVismaPeopleInfo.company}</b></p>
        </div>
      )
    } 

    if(!isNull(infoSuccess) && !this.props.validateVismaPeopleInfo.success) {
      return (
        <div>
          <p className="error-message"><img src={xIconCircle} /> Usuario, contraseña y/o tenant inválidos.</p>
        </div>
      )
    }
    
    return <><b>Llena</b> todos los campos y haz <b>click en “Validar”</b> para luego ingresar los IDs de estructuras.</>
  }

  showStructureFieldsFeedback = () => {

    let structureSuccess = get(this.props.validateVismaPeopleStructure, "success", null)

    if(!isNull(structureSuccess)) {
      return this.showStructuresFeedback()
    }

    return <><b>Llena</b> todos los campos y haz <b>click en “Validar”</b> para verificar que los IDs han sido identificados.</>
  }

  handleUrlPerformanceChange = async (value) => {
    this.setFormData("performance_subdomain", value)
    this.setState({ urlPerformanceError: null })
    
    if (!value) {
      return
    }

    // Validate URL format - Updated to accept multiple subdomains
    const urlPattern = /^https:\/\/[a-zA-Z0-9.-]+\.manduhr\.com$/
    if (!urlPattern.test(value)) {
      this.setState({ 
        urlPerformanceError: "La URL no cumple con el formato válido https://nombredeempresa.manduhr.com" 
      })
      return
    }

    // Validate if URL already exists in another company
    try {
      const requestData = { url: value }
      
      // Include company_id when editing (exclude current company from validation)
      if (!this.is_new && this.state.companyId) {
        requestData.company_id = this.state.companyId
      }
      
      const response = await validateUrlPerformance(requestData)
      
      // If the API returns that the URL exists in another company
      if (response.data && response.data.exists) {
        this.setState({ 
          urlPerformanceError: "La URL ya está asociada a una empresa" 
        })
      }
    } catch (error) {
      // Handle API error - could be network error or server error
      console.error('Error validating URL:', error)
      
      // Check if it's a validation error (URL exists)
      if (error.response && error.response.status === 409) {
        this.setState({ 
          urlPerformanceError: "La URL ya está asociada a una empresa" 
        })
      }
    }
  }

  renderTab = () => {
    const { tab, formData, companyId, showError } = this.state
    const {
      options,
      users,
      users_loading,
      form,
      loading_switcher_admin,
    } = this.props
    const licenses = options.licenses ? options.licenses : []
    const currentLicense = licenses.find(
      (license) => license.id_license === formData.id_license
    )
    const isLicenseFreemium = !currentLicense
      ? false
      : currentLicense.id_license === 1 // 1 id for freemium
    const trialStartDate = moment(formData.trial_start_date).isValid()
      ? moment(formData.trial_start_date)
      : null
    const daysRemaining = moment(formData.trial_start_date).isValid()
      ? this.setToInitialDay(moment(formData.trial_start_date))
          .add(formData.trial_duration, "days")
          .diff(this.setToInitialDay(moment()), "days")
      : 0

    const validateEmail = (email) => {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    }

    const handleAddAccountManager = (e) => {
      let value = e.target.value
      if (e.key === "Enter") {
        if (value.includes(",")) {
          let values = value.split(",").map((item) => item.trim())
          let validFormat = values.every((item) => validateEmail(item))

          if (!validFormat)
            return this.setState({
              showError:
                "El correo electrónico se encuentra en un formato inválido.",
            })

          let validManduFormat = values.every(
            (item) => /@visma.com\s*$/.test(item) || /@mandu.pe\s*$/.test(item)
          )

          if (!validManduFormat)
            return this.setState({
              showError:
                "El correo ingresado no pertenece al dominio de Visma (@visma.com) o Mandü (@mandu.pe).",
            })

          this.setState({ showError: null })
          const newValues = Array.from(
            new Set([...formData.account_manager, ...values])
          )
          this.setFormData("account_manager", newValues)
          this.setState({ currentAccountManager: "" })
        } else {
          let isValid = validateEmail(value)

          if (!isValid)
            return this.setState({
              showError:
                "El correo electrónico se encuentra en un formato inválido.",
            })

          let isMandu =
            /@visma.com\s*$/.test(value) || /@mandu.pe\s*$/.test(value)

          if (!isMandu)
            return this.setState({
              showError:
                "El correo ingresado no pertenece al dominio de Visma (@visma.com) o Mandü (@mandu.pe).",
            })

          this.setState({ showError: false })

          const newValues = Array.from(
            new Set([...formData.account_manager, value])
          )
          this.setFormData("account_manager", newValues)
          this.setState({ currentAccountManager: "" })
        }
      }
    }
    let sector_id = formData.sectorGlobal
    if (sector_id == 0) sector_id = null

    switch (tab) {
      case 1:
        return (
          <Fragment>
            <div className="AdministratorCompaniesForm-body-content-section">
              <div className="AdministratorCompaniesForm-body-content-section-title">
                <span>INFORMACIÓN</span>
                <Divider />
              </div>
              <div className="AdministratorCompaniesForm-body-content-section-form">
                <div>
                  <Form.Item>
                    {form.getFieldDecorator("demo", {
                      initialValue: formData.demo,
                    })(
                      <Checkbox
                        checked={formData.demo}
                        onChange={(e) =>
                          this.setFormData("demo", e.target.checked)
                        }>
                        Demo
                      </Checkbox>
                    )}
                  </Form.Item>
                </div>
                <div>
                  <h4>ID Hubspot</h4>
                  <div>
                    <Form.Item>
                      {form.getFieldDecorator("hubspot_company_id", {
                        initialValue: formData.hubspot_company_id,
                        rules: [
                          {
                            pattern: new RegExp(/^[a-zA-Z0-9]+$/i),
                            message: "Ingresar solo letras y números",
                          },
                        ],
                      })(
                        <Input
                          maxLength={40}
                          onChange={(e) =>
                            this.setFormData(
                              "hubspot_company_id",
                              e.target.value
                            )
                          }
                          autoComplete="newpassword"
                          style={{ width: 300 }}
                          placeholder="ID Hubspot"
                          disabled={formData.disabled}
                        />
                      )}
                    </Form.Item>
                  </div>
                </div>
              </div>
              <div className="AdministratorCompaniesForm-body-content-section-form">
                <h4>Nombre</h4>
                <div>
                  <Form.Item>
                    {form.getFieldDecorator("email", {
                      initialValue: formData.name,
                      rules: [
                        {
                          required: true,
                          message: formLabelMessage("es", "required"),
                        },
                      ],
                    })(
                      <Input
                        maxLength={100}
                        onChange={(e) =>
                          this.setFormData("name", e.target.value)
                        }
                        autoComplete="newpassword"
                        style={{ width: 300 }}
                        placeholder="Nombre de empresa"
                        disabled={formData.disabled}
                      />
                    )}
                  </Form.Item>
                </div>
              </div>
              <div className="AdministratorCompaniesForm-body-content-section-form-grid180">
                <div>
                  <h4>Sector</h4>
                  <div>
                    <Form.Item>
                      {form.getFieldDecorator("sectorGlobal", {
                        initialValue: sector_id,
                        rules: [
                          {
                            required: true,
                            message: formLabelMessage("es", "required"),
                          },
                        ],
                      })(
                        <Select
                          onChange={(e) => this.setFormData("sectorGlobal", e)}
                          showSearch
                          autoComplete="newpassword"
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          placeholder="Seleccionar"
                          style={{ width: "100%" }}
                          disabled={formData.disabled}>
                          {options.sectors &&
                            options.sectors.map((se, seI) => (
                              <Option key={seI} value={se.id}>
                                {se.name}
                              </Option>
                            ))}
                        </Select>
                      )}
                    </Form.Item>
                  </div>
                </div>
                <div>
                  <h4>Tamaño</h4>
                  <div>
                    <Form.Item>
                      {form.getFieldDecorator("size", {
                        initialValue: formData.size,
                        rules: [
                          {
                            required: true,
                            message: formLabelMessage("es", "required"),
                          },
                        ],
                      })(
                        <Select
                          onChange={(e) => this.setFormData("size", e)}
                          showSearch
                          autoComplete="newpassword"
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          placeholder="Seleccionar"
                          style={{ width: "100%" }}
                          disabled={formData.disabled}>
                          {options.sizes &&
                            options.sizes.map((s, sI) => (
                              <Option key={sI} value={s.id}>
                                {s.name.replace(/\./g, ",")}
                              </Option>
                            ))}
                        </Select>
                      )}
                    </Form.Item>
                  </div>
                </div>
                <div>
                  <h4>País</h4>
                  <div>
                    <Form.Item>
                      {form.getFieldDecorator("country", {
                        initialValue: formData.country,
                        rules: [
                          {
                            required: true,
                            message: formLabelMessage("es", "required"),
                          },
                        ],
                      })(
                        <Select
                          onChange={(e) => this.setFormData("country", e)}
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          showSearch
                          autoComplete="newpassword"
                          placeholder="Seleccionar"
                          style={{ width: "100%" }}
                          disabled={formData.disabled}>
                          {options.country &&
                            options.country.map((c, cI) => (
                              <Option key={cI} value={c.iso_3166_1_alpha2}>
                                {c.translations}
                              </Option>
                            ))}
                        </Select>
                      )}
                    </Form.Item>
                  </div>
                </div>
              </div>
            </div>
           
              <div className="AdministratorCompaniesForm-body-content-section-form">
                <h4>URL Performance</h4>
                <div>
                  <Form.Item
                    validateStatus={this.state.urlPerformanceError ? "error" : ""}
                    help={this.state.urlPerformanceError}>
                    {form.getFieldDecorator("performance_subdomain", {
                      initialValue: formData.performance_subdomain,
                      rules: [
                        {
                          pattern: /^https:\/\/[a-zA-Z0-9.-]+\.manduhr\.com$/,
                          message: "La URL no cumple con el formato válido https://nombredeempresa.manduhr.com",
                        },
                      ],
                    })(
                      <Input
                        maxLength={100}
                        onChange={(e) => this.handleUrlPerformanceChange(e.target.value)}
                        autoComplete="newpassword"
                        style={{ 
                          width: 400,
                          borderColor: this.state.urlPerformanceError ? '#ff4d4f' : undefined
                        }}
                        placeholder="Ej. https://nombredeempresa.manduhr.com"
                        disabled={formData.disabled}
                      />
                    )}
                  </Form.Item>
                </div>
              </div>
            
            <div className="AdministratorCompaniesForm-body-content-section">
              <div className="AdministratorCompaniesForm-body-content-section-title">
                <span>LICENCIA</span>
                <Divider />
              </div>
              <div className="AdministratorCompaniesForm-body-content-section-form-gridLicence">
                <div>
                  <h4>Licencia</h4>
                  <div>
                    <Form.Item>
                      {form.getFieldDecorator("id_license", {
                        initialValue: formData.id_license,
                        rules: [
                          {
                            required: true,
                            message: formLabelMessage("es", "required"),
                          },
                        ],
                      })(
                        <Select
                          autoComplete="newpassword"
                          onChange={(e) => this.setFormData("id_license", e)}
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          showSearch
                          placeholder="Seleccionar"
                          style={{ width: "100%" }}
                          disabled={formData.disabled}>
                          {options.licenses &&
                            options.licenses.map((license, licenseIdx) => (
                              <Option
                                key={licenseIdx}
                                value={license.id_license}>
                                {license.name}
                              </Option>
                            ))}
                        </Select>
                      )}
                    </Form.Item>
                  </div>
                </div>
                <div>
                  <h4>Colaboradores</h4>
                  <div>
                    {isLicenseFreemium ? (
                      <Form.Item>
                        {form.getFieldDecorator("trial_max_collaborators", {
                          initialValue: formData.trial_max_collaborators,
                          rules: [
                            {
                              required: true,
                              message: formLabelMessage("es", "required"),
                            },
                          ],
                        })(
                          <InputNumber
                            min={0}
                            autoComplete="newpassword"
                            placeholder="0"
                            onChange={(e) =>
                              this.setFormData("trial_max_collaborators", e)
                            }
                          />
                        )}
                      </Form.Item>
                    ) : (
                      <Form.Item>
                        {form.getFieldDecorator("collaborator", {
                          initialValue: formData.collaborator,
                          rules: [
                            {
                              required: true,
                              message: formLabelMessage("es", "required"),
                            },
                          ],
                        })(
                          <Select
                            onChange={(e) =>
                              this.setFormData("collaborator", e)
                            }
                            autoComplete="newpassword"
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            showSearch
                            placeholder="Seleccionar"
                            style={{ width: "100%" }}
                            disabled={formData.disabled}>
                            {options.collaborators &&
                              options.collaborators.map((col, colI) => (
                                <Option key={colI} value={col.id}>
                                  {col.name.replace(/\./g, ",")}
                                </Option>
                              ))}
                          </Select>
                        )}
                      </Form.Item>
                    )}
                  </div>
                </div>
                {isLicenseFreemium && (
                  <>
                    <div>
                      <h4>Fecha de inicio</h4>
                      <div>
                        <Form.Item>
                          {form.getFieldDecorator("trial_start_date", {
                            initialValue: trialStartDate,
                            rules: [
                              {
                                required: true,
                                message: formLabelMessage("es", "required"),
                              },
                            ],
                          })(
                            <DatePicker
                              placeholder="Seleccionar"
                              autoComplete="newpassword"
                              format="DD-MM-YYYY"
                              // disabledDate={current => current && current < moment().startOf('day')}
                              onChange={(e) =>
                                this.setFormData("trial_start_date", e)
                              }
                            />
                          )}
                        </Form.Item>
                      </div>
                    </div>
                    <div>
                      <h4>Duración (días)</h4>
                      <div>
                        <Form.Item>
                          {form.getFieldDecorator("trial_duration", {
                            initialValue: formData.trial_duration,
                            rules: [
                              {
                                required: true,
                                message: formLabelMessage("es", "required"),
                              },
                            ],
                          })(
                            <InputNumber
                              autoComplete="newpassword"
                              style={{ width: 60 }}
                              min={0}
                              placeholder="0"
                              onChange={(e) =>
                                this.setFormData("trial_duration", e)
                              }
                            />
                          )}
                          {formData.trial_start_date && (
                            <span
                              className="color-gray-low"
                              style={{ marginLeft: 10 }}>
                              El sistema estará habilitado hasta el{" "}
                              {moment(formData.trial_start_date)
                                .add(formData.trial_duration, "days")
                                .format("DD-MM-YYYY")}{" "}
                              ({daysRemaining} días restantes).
                            </span>
                          )}
                        </Form.Item>
                      </div>
                    </div>
                  </>
                )}
                <div className="account_manager">
                  <h4>Account manager</h4>
                  <div>
                    <Form.Item>
                      {form.getFieldDecorator("account_manager", {
                        initialValue: formData.account_manager,
                        rules: [
                          {
                            required: true,
                            message: formLabelMessage("es", "required"),
                          },
                        ],
                      })(
                        <>
                          <Input
                            autoComplete="newpassword"
                            maxLength={100}
                            type="email"
                            onKeyPress={handleAddAccountManager}
                            value={this.state.currentAccountManager}
                            onChange={(e) =>
                              this.setState({
                                currentAccountManager: e.target.value,
                              })
                            }
                            style={{ width: 360 }}
                            placeholder="Account Manager"
                            disabled={formData.disabled}
                          />
                        </>
                      )}
                    </Form.Item>
                  </div>
                  {showError && (
                    <div className="account_manager-error_message">
                      {showError}
                    </div>
                  )}

                  <div
                    className="account_manager-info"
                    style={{
                      marginTop: `${this.state.showError ? "4px" : "-20px"}`,
                    }}>
                    Escribe el correo y presiona “Enter” para agregarlo. Si
                    deseas introducir más de uno, utiliza una coma como
                    separación y luego presiona Enter.
                  </div>
                  <div className="account_manager-list">
                    {formData?.account_manager?.map((item, i) => (
                      <div
                        className="account"
                        key={item + i}
                        style={{ marginTop: 10 }}>
                        {item}
                        <span
                          style={{
                            marginLeft: 5,
                            fontSize: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            let acc = [...formData.account_manager]
                            acc.splice(i, 1)
                            this.setFormData("account_manager", acc)
                          }}>
                          X
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="support_channel">
                  <h4>Soporte</h4>
                  <div>
                    <Form.Item>
                      {form.getFieldDecorator("support_channel", {
                        initialValue: formData.performance_support_channel || formData.support_channel,
                        rules: [
                          {
                            required: true,
                            message: formLabelMessage("es", "required"),
                          },
                        ],
                      })(
                        <Select
                          style={{ width: 200 }}
                          placeholder="Selecciona un canal"
                          onChange={(e) => this.setFormData("support_channel", e)}
                          disabled={formData.disabled}
                        >
                          <Option value="PE">Perú</Option>
                          <Option value="AR">Argentina</Option>
                        </Select>
                      )}
                    </Form.Item>
                  </div>
                </div>
              </div>
            </div>
            <div className="AdministratorCompaniesForm-body-content-section">
              <div className="AdministratorCompaniesForm-body-content-section-title">
                <span>FUNCIONALIDADES HABILITADAS</span>
                <Divider />
              </div>
              <div className="AdministratorCompaniesForm-body-content-section-form visma-people-form">
                <div className="AdministratorCompaniesForm-body-content-section-form-item" style={{ marginTop: 8 }}>
                  {form.getFieldDecorator("top_three_box_enable", {
                      initialValue: formData.top_three_box_enable,
                    })(
                      <Switch
                        checked={formData.top_three_box_enable}
                        onChange={(e) => {
                          this.setFormData("top_three_box_enable", e);
                        }}
                      />
                    )}
                  <div>
                    <div className="AdministratorCompaniesForm-body-content-section-form-item__title">
                      Top three box
                    </div>
                    <p>
                      Habilita el cálculo de top three box para el cálculo de la nota de Engagement y del outcome Recomendación, cuando el eNPS utilice una escala del 0 al 10.
                    </p>
                  </div>
                </div>
                <div className="AdministratorCompaniesForm-body-content-section-form-item"
                  style={{ marginTop: 8 }}>
                  {form.getFieldDecorator("pdas_ia_enable", {
                      initialValue: formData.pdas_ia_enable,
                    })(
                      <Switch
                        checked={formData.pdas_ia_enable}
                        onChange={(e) => {
                          this.setFormData("pdas_ia_enable", e);
                        }}
                      />
                    )}
                  <div>
                  <div className="AdministratorCompaniesForm-body-content-section-form-item__title">
                    Planes de acción con IA
                    </div>
                    <p>
                      Habilita la creación de Planes de acción con inteligencia artificial.
                    </p>
                  </div>
                </div>
                <div className="AdministratorCompaniesForm-body-content-section-form-item"
                    style={{ marginTop: 8 }}>
                    
                    {(this.is_new || (this.props.current_company.active && this.props.current_company.visma_people_available && this.props.current_company.visma_people_new_company) || this.props.current_company.visma_people_sync_enabled) ? (
                      form.getFieldDecorator("visma_people_sync_request", {
                        initialValue: formData.visma_people_sync_request,
                      })(
                        <Switch
                          onClick={this.toggleVismaPeopleSync}
                          checked={formData.visma_people_sync_request}
                          onChange={(e) => {return} }
                        />
                      )
                    ) : <></>}
                    <div>
                      {(this.is_new || this.props.current_company.visma_people_sync_enabled || (this.props.current_company.active && this.props.current_company.visma_people_available && this.props.current_company.visma_people_new_company) || this.props.current_company.visma_people_sync_enabled) ? (
                        <div style={{ marginBottom: 12 }}>
                          <div className="AdministratorCompaniesForm-body-content-section-form-item__title">
                            Sincronizar con Visma People
                          </div>
                          <p>
                            Se enviará un ticket a Soporte para solicitar la integración de los datos de los colaboradores de la empresa con Visma People. Cualquier cambio hecho en dicha plataforma, será aplicado durante la sincronización en Clima & Engagement.
                          </p>
                        </div>
                      ) : <></>}
                      {(this.is_new || this.props.current_company.visma_people_sync_enabled || (this.props.current_company.active && this.props.current_company.visma_people_available && this.props.current_company.visma_people_new_company)) ? (
                        <div className="AdministratorCompaniesForm-body-subform" style={{ marginTop: 30 }}>
                          
                            <div className="AdministratorCompaniesForm-body-subform__body">
                              <div className="AdministratorCompaniesForm-body-subform-section">
                                <h4 className="AdministratorCompaniesForm-body-subform-section__title">Información general</h4>
                                <div className="AdministratorCompaniesForm-body-subform-section__form">
                                  <div>
                                    <h4>
                                    {(!this.props.current_company.visma_people_sync_request && !this.props.current_company.visma_people_sync_enabled) ? <>Usuario<span className="required">*</span></> : "Empresa"}
                                    </h4>
                                    {(!this.props.current_company.visma_people_sync_request && !this.props.current_company.visma_people_sync_enabled) ? (
                                      <Form.Item>
                                        {form.getFieldDecorator("visma_people_user", {
                                          initialValue: formData.visma_people_user,
                                        })(
                                          <Input
                                            maxLength={80}
                                            onChange={(e) => {
                                              this.setFormData(
                                                "visma_people_user",
                                                e.target.value
                                              )
                                              if(this.props.validateVismaPeopleInfoRequested && (this.state.vismaPeopleData !== `${e.target.value}${formData.visma_people_password}${formData.visma_people_tenant}`)) {
                                                this.props.updateValidateVismaPeopleRequested(false)
                                                this.props.resetVismaPeopleStructureValidations()
                                              }
                                            }
                                            }
                                            placeholder="Correo"
                                            disabled={(formData.disabled || !this.state.formData.visma_people_sync_request) || this.props.current_company.visma_people_sync_request}
                                          />
                                        )}
                                      </Form.Item>
                                    ) : (
                                      <>{this.props.current_company.visma_people_tenant_name}</>
                                    )}
                                  </div>
                                  <div>
                                    {(!this.props.current_company.visma_people_sync_request && !this.props.current_company.visma_people_sync_enabled) ? (
                                      <>
                                        <h4>Contraseña<span className="required">*</span></h4>
                                        <Form.Item >
                                          {form.getFieldDecorator("visma_people_password", {
                                            initialValue: formData.visma_people_password,
                                          })(
                                            <Input.Password
                                              maxLength={80}
                                              onChange={(e) => {
                                                this.setFormData(
                                                  "visma_people_password",
                                                  e.target.value
                                                )
                                                if(this.props.validateVismaPeopleInfoRequested && (this.state.vismaPeopleData !== `${formData.visma_people_user}${e.target.value}${formData.visma_people_tenant}`)) {
                                                  this.props.updateValidateVismaPeopleRequested(false)
                                                  this.props.resetVismaPeopleStructureValidations()
                                                }
                                              }
                                              }
                                              iconRender={(visible) => {
                                                if(!formData.visma_people_password || formData.visma_people_password === "") {
                                                  return <></>
                                                }
                                                return visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                              }}
                                              placeholder="Contraseña"
                                              disabled={(formData.disabled || !this.state.formData.visma_people_sync_request) || this.props.current_company.visma_people_sync_request}
                                            />
                                          )}
                                        </Form.Item>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                  <div>
                                    {(!this.props.current_company.visma_people_sync_request && !this.props.current_company.visma_people_sync_enabled) ? (
                                      <>
                                        <h4>Tenant<span className="required">*</span></h4>
                                        <Form.Item>
                                          {form.getFieldDecorator("visma_people_tenant", {
                                            initialValue: formData.visma_people_tenant,
                                          })(
                                            <Input
                                              maxLength={10}
                                              onKeyPress={(e) => {
                                                const charCode = typeof e.which == "undefined" ? e.keyCode : e.which;
                                                if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                                                  e.preventDefault();
                                                }
                                              }}
                                              onPaste={(e)=> e.preventDefault()}
                                              onDrop={(e)=> e.preventDefault()}
                                              onChange={(e) => {
                                                  
                                                  this.setFormData(
                                                    "visma_people_tenant",
                                                    e.target.value
                                                  )
                                                  
                                                  if(this.props.validateVismaPeopleInfoRequested && (this.state.vismaPeopleData !== `${formData.visma_people_user}${formData.visma_people_password}${e.target.value}`)) {
                                                    this.props.updateValidateVismaPeopleRequested(false)
                                                    this.props.resetVismaPeopleStructureValidations()

                                                  }
                                                }
                                              }
                                              placeholder="Código"
                                              disabled={(formData.disabled || !this.state.formData.visma_people_sync_request) || this.props.current_company.visma_people_sync_request}
                                            />
                                          )}
                                        </Form.Item>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                                {(!this.props.current_company.visma_people_sync_request && !this.props.current_company.visma_people_sync_enabled) && (
                                  <div className="AdministratorCompaniesForm-body-subform-section__footer">
                                    <p className="text">
                                      {this.showFieldsFeedback()}
                                    </p>
                                    <Button 
                                      loading={this.props.validateVismaPeopleInfoLoading} 
                                      onClick={this.handleValidateVismaPeopleInfo} 
                                      type="primary" 
                                      disabled={this.disableVismaPeopleInfoButton()}>
                                        Validar
                                    </Button>
                                  </div>
                                )}
                              </div>
                              <div className="AdministratorCompaniesForm-body-subform-section">
                                <h4 className="AdministratorCompaniesForm-body-subform-section__title">IDs de estructuras</h4>
                                <div className="AdministratorCompaniesForm-body-subform-section__form">
                                  <div>
                                    <h4>ID Ubicación geográfica{(!this.props.current_company.visma_people_sync_request && !this.props.current_company.visma_people_sync_enabled) ? <span className="required">*</span> : <></>}</h4>
                                    {(!this.props.current_company.visma_people_sync_request && !this.props.current_company.visma_people_sync_enabled) ? (
                                      <Form.Item>
                                        {form.getFieldDecorator("visma_people_id_geographic_location", {
                                          initialValue: formData.visma_people_id_geographic_location,
                                        })(
                                          <Input
                                            maxLength={20}
                                            onPaste={(e)=> e.preventDefault()}
                                            onDrop={(e)=> e.preventDefault()}
                                            onChange={(e) => {
                                                this.setFormData(
                                                  "visma_people_id_geographic_location",
                                                  e.target.value
                                                )

                                                if(this.props.validateVismaPeopleStructureRequested && (this.state.vismaPeopleDataStructure !== `${e.target.value}${formData.visma_people_id_herarquical_category}${formData.visma_people_id_position}`)) {
                                                  this.props.updateValidateVismaPeopleStructureRequested(false)
                                                }
                                              }
                                            }
                                            onKeyPress={(e) => {
                                              const charCode = typeof e.which == "undefined" ? e.keyCode : e.which;
                                              if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                                                e.preventDefault();
                                              }
                                            }}
                                            placeholder="ID"
                                            disabled={!this.props.validateVismaPeopleInfo.success || this.props.current_company.visma_people_sync_request || this.disabledStructureFields()}
                                          />
                                        )}
                                      </Form.Item>
                                    ) : <>Estructura: {this.props.current_company.visma_people_geographic_location_name}</>}
                                  </div>
                                  <div>
                                    <h4>ID Categoría jerárquica{(!this.props.current_company.visma_people_sync_request && !this.props.current_company.visma_people_sync_enabled) ? <span className="required">*</span> : <></>}</h4>
                                    {(!this.props.current_company.visma_people_sync_request && !this.props.current_company.visma_people_sync_enabled) ? (
                                      <Form.Item >
                                        {form.getFieldDecorator("visma_people_id_herarquical_category", {
                                          initialValue: formData.visma_people_id_herarquical_category,
                                        })(
                                          <Input
                                            maxLength={20}
                                            onPaste={(e)=> e.preventDefault()}
                                            onDrop={(e)=> e.preventDefault()}
                                            onChange={(e) => {

                                              this.setFormData(
                                                "visma_people_id_herarquical_category",
                                                e.target.value
                                              )
                                              if(this.props.validateVismaPeopleStructureRequested && (this.state.vismaPeopleDataStructure !== `${formData.visma_people_id_herarquical_category}${e.target.value}${formData.visma_people_id_position}`)) {
                                                this.props.updateValidateVismaPeopleStructureRequested(false)
                                              }
                                            }
                                              
                                            }
                                            onKeyPress={(e) => {
                                              const charCode = typeof e.which == "undefined" ? e.keyCode : e.which;
                                              if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                                                e.preventDefault();
                                              }
                                            }}
                                            placeholder="ID"
                                            disabled={!this.props.validateVismaPeopleInfo.success || this.props.current_company.visma_people_sync_request || this.disabledStructureFields()}
                                          />
                                        )}
                                      </Form.Item>
                                    ) : <>Estructura: {this.props.current_company.visma_people_herarquical_category_name}</>}
                                  </div>
                                  <div>
                                    <h4>ID Puesto{(!this.props.current_company.visma_people_sync_request && !this.props.current_company.visma_people_sync_enabled) ? <span className="required">*</span> : <></>}</h4>
                                    {(!this.props.current_company.visma_people_sync_request && !this.props.current_company.visma_people_sync_enabled) ? (
                                      <Form.Item>
                                        {form.getFieldDecorator("visma_people_id_position", {
                                          initialValue: formData.visma_people_id_position,
                                        })(
                                          <Input
                                            maxLength={20}
                                            onPaste={(e)=> e.preventDefault()}
                                            onDrop={(e)=> e.preventDefault()}
                                            onChange={(e) => {
                                              this.setFormData(
                                                "visma_people_id_position",
                                                e.target.value
                                              )
                                              if(this.props.validateVismaPeopleStructureRequested && (this.state.vismaPeopleDataStructure !== `${formData.visma_people_id_herarquical_category}${formData.visma_people_id_geographic_location}${e.target.value}`)) {
                                                this.props.updateValidateVismaPeopleStructureRequested(false)
                                              }
                                            }
                                              
                                            }
                                            onKeyPress={(e) => {
                                              const charCode = typeof e.which == "undefined" ? e.keyCode : e.which;
                                              if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                                                e.preventDefault();
                                              }
                                            }}
                                            placeholder="ID"
                                            disabled={!this.props.validateVismaPeopleInfo.success || this.props.current_company.visma_people_sync_request || this.disabledStructureFields()} 
                                          />
                                        )}
                                      </Form.Item>
                                    ) : <>Estructura: {this.props.current_company.visma_people_position_name}</>}
                                  </div>
                                </div>
                                {(!this.props.current_company.visma_people_sync_request && !this.props.current_company.visma_people_sync_enabled) && (
                                  <div class="AdministratorCompaniesForm-body-subform-section__footer">
                                    <p class="text">
                                      {this.showStructureFieldsFeedback()}
                                    </p>
                                    <Button 
                                      loading={this.props.validateVismaPeopleStructureLoading}
                                      type="primary"
                                      onClick={this.handleValidateVismaPeopleStructure}
                                      disabled={this.disableVismaPeopleStructureButton() || this.disabledStructureFields()}>
                                      Validar
                                    </Button>
                                  </div>
                                )}
                              </div>
                            </div>
                          
                        </div>
                      ) : <></>}
                    </div>
                </div>
              </div>
            </div>
            
          </Fragment>
        )
      case 3:
        if(!this.is_new && !this.checkUsersLoading()) {
          return (
            <div className="AdministratorCompaniesForm-body-content-section">
              <div className="AdministratorCompaniesForm-body-content-section-title">
                <span>
                  ADMINISTRADORES{" "}
                  <div
                    className="color-gray-low"
                    style={{ fontWeight: 400, display: "inline" }}>
                    ({users.length || 0})
                  </div>
                </span>
                <Divider />
              </div>
              <div
                className="AdministratorCompaniesForm-body-content-section-form"
                style={{ maxWidth: "90%" }}>
                <div className="color-blue">
                  <Button
                    type="link"
                    onClick={() => {
                      if (!formData.disabled)
                        this.setState({
                          modalCreateUser: true,
                          modalAdminTitle: "Crear usuario",
                          userSelected: {},
                        })
                    }}>
                    + Crear administrador
                  </Button>
                </div>
                <AdministratorList
                  loading={loading_switcher_admin}
                  company_id={companyId}
                  userDelete={(e) => {
                    if (!formData.disabled)
                      this.setState({ modalAdminDelete: true, userSelected: e })
                  }}
                  userSelected={(e) => {
                    if (!formData.disabled)
                      this.setState({
                        userSelected: e,
                        modalCreateUser: true,
                        modalAdminTitle: "Editar usuario",
                      })
                  }}
                  usersSASwitch={this.props.usersSASwitch}
                  users={users}
                  users_loading={users_loading}
                  disabled={formData.disabled}
                />
              </div>
            </div>
          )
        }

    }
  }

  toggleVismaPeopleSync = async (e) => {
    if(this.state.formData.visma_people_sync_request) {
      this.setState({modalDisableVismaPeopleSync: true })
    } else {
      this.setFormData('visma_people_sync_request', false)
      this.setState({ modalEnableVismaPeopleSync: true });
    }

  }

  disabledStructureFields = () => {
    
    if(this.props.validateVismaPeopleInfo.success) {

      if(this.props.validateVismaPeopleInfoLoading || this.state.vismaPeopleData !== `${this.state.formData.visma_people_user}${this.state.formData.visma_people_password}${this.state.formData.visma_people_tenant}`) {
        return true
      }
    }

    return false
  }

  disableVismaPeopleInfoButton = () => {

    if(!this.state.formData.visma_people_sync_request) {
      return true
    }

    if(this.props.validateVismaPeopleInfoRequested) {

      let currentValue = `${this.state.formData.visma_people_user}${this.state.formData.visma_people_password}${this.state.formData.visma_people_tenant}`

      if(currentValue === this.state.vismaPeopleData) {
        return true
      }

      if(this.props.validateVismaPeopleInfo.success) {
        return true
      }

      return true
    }

    const { visma_people_user, visma_people_password, visma_people_tenant } = this.state.formData;
    return !visma_people_user || !visma_people_password || !visma_people_tenant;
  };

  disableVismaPeopleStructureButton = () => {

    if(!this.state.formData.visma_people_sync_request) {
      return true
    }

    if(!this.props.validateVismaPeopleInfo.success) {
      return true
    }

    if(this.props.validateVismaPeopleStructureRequested) {

      let currentValue = `${this.state.visma_people_id_geographic_location}${this.state.visma_people_id_herarquical_category}${this.state.visma_people_id_position}`

      if(currentValue === this.state.vismaPeopleDataStructure) {
        return true
      }

      if(this.props.validateVismaPeopleStructure.success) {
        return true
      }

      return true
    }

    const { visma_people_id_geographic_location, visma_people_id_herarquical_category, visma_people_id_position } = this.state.formData;
    return !visma_people_id_geographic_location || !visma_people_id_herarquical_category || !visma_people_id_position;
  }

  checkIfStructureFieldsAreEmpty = () => {
  }


  validateRequiredFormFields = () => {

    let validField = true


    Object.keys(this.state.formData).forEach(key => {
      
      let value = this.state.formData[key]

      if(['hubspot_company_id', 'performance_subdomain', 'performance_support_channel'].includes(key)) {
        return
      }

      if (this.state.formData.id_license !== 1 && (['trial_start_date', 'trial_duration'].includes(key))) {
        return
      }

      if((!this.props.current_company.visma_people_available || 
          !this.props.current_company.visma_people_sync_enabled) && 
          ['visma_people_available', 
          'visma_people_id_geographic_location', 
          'visma_people_id_herarquical_category', 
          'visma_people_id_position',
          'visma_people_password',
          'visma_people_tenant',
          'visma_people_user'
        ].includes(key)) {
          return
      }

      if(isArray(value) && value.length === 0) {
        return validField = false
      }

      if(value === null || value === "" || value === undefined) {
        return validField = false
      }
    });
    
    return validField
  }

  checkIfSaveButtonIsDisabled = () => {

    if(!this.validateRequiredFormFields()) { 
      return true
    }

    if(!this.props.current_company.visma_people_available) {
      return false
    }

    if(this.validateRequiredFormFields() && !this.state.formData.visma_people_sync_request) {
      return false
    }

    // VP integration was already saved in the backend — credentials do not need
    // re-validation in the current session.  Only require VP validation when the
    // user is enabling VP for the first time in this editing session (i.e.
    // current_company.visma_people_sync_request was false before this edit).
    const vpAlreadySaved = !!this.props.current_company.visma_people_sync_request
    if(this.state.formData.visma_people_sync_request && !vpAlreadySaved && (!this.props.validateVismaPeopleInfo.success || !this.props.validateVismaPeopleStructure.success)) {
      return true
    }

    if(this.props.validateVismaPeopleInfo.success && this.props.validateVismaPeopleStructure.success) {
      return false
    }

    // VP is already saved: allow save when form fields are valid (checked above)
    if(vpAlreadySaved) {
      return false
    }

    return true
  }

  renderDisableCompanySwitch = () => {
    const { formData, companyId } = this.state
    const { options } = this.props
    const licenses = options.licenses ? options.licenses : []
    const currentLicense = licenses.find(
      (license) => license.id_license === formData.id_license
    )
    const isLicenseFreemium = !currentLicense
      ? false
      : currentLicense.id_license === 1 // 1 id for freemium
    const daysRemaining = moment(formData.trial_start_date).isValid()
      ? this.setToInitialDay(moment(formData.trial_start_date))
          .add(formData.trial_duration, "days")
          .diff(this.setToInitialDay(moment()), "days")
      : 0

    if (
      isLicenseFreemium &&
      moment(formData.trial_start_date).isValid() &&
      daysRemaining <= 0
    ) {
      return (
        <Popover
          placement="bottomLeft"
          content={
            <div className="text-center" style={{ width: 240 }}>  
              La versión de prueba ha <b>expirado</b>. Para poder activarla de
              nuevo, extiende la <b>duración</b>.
            </div>
          }>
          <Switch checked={false} />
        </Popover>
      )
    }

    const renderSwitchContent = () => {
      return <Switch
        onChange={(e) => {
          if (formData.active) {
            this.setState({ modalSwitchCompany: true })
          } else {
            this.setFormData("active", e)
            this.props.statusCompany({ company_id: companyId, active: e })
          }
        }}
        checked={!!formData.active}
        disabled={formData.disabled || this.props.current_company.visma_people_sync_enabled}
      />
    }

    if(this.props.current_company.visma_people_sync_enabled) {

      const content = (
        <>No es posible desactivar esta función<br /> porque hay un proceso de <b>sincronización<br/> con Visma People en curso.</b></>
      );

      return (
        <Popover content={content} placement="left" >
          {renderSwitchContent()}
        </Popover>
      )
    }

    return (
      <Tooltip title={formData.active ? "Apagar empresa" : "Encender empresa"} >
        {renderSwitchContent()}
      </Tooltip>
    )
  }

  render() {
    const {
      modalCompanyDelete,
      modalCreateUser,
      modalAdminTitle,
      formData,
      formDataBackup,
      companyId,
      tab,
      modalSwitchCompany,
      userSelected,
      modalAdminDelete,
      modalChangeLicense,
    } = this.state
    const { save_loading, delete_loading, users, options } = this.props
    const licenses = options.licenses ? options.licenses : []
    const currentLicense = licenses.find(
      (license) => license.id_license === formData.id_license
    )
    const isLicenseFreemium = !currentLicense
      ? false
      : currentLicense.id_license === 1 // 1 id for freemium
    let compareData = JSON.parse(JSON.stringify(formData))
    delete compareData.active

    let compareDataBackup = JSON.parse(JSON.stringify(formDataBackup))
    delete compareDataBackup.active

    return (
      <Layout>
        <Helmet>
          <title>Empresas</title>
          <meta name="description" content="Compañías" />
        </Helmet>
        <div
          style={{ display: "flex", flexDirection: "column" , background: !this.is_new ? "white" : ""}}
          className="buttonsFooter"
        >
          <div
            className="AdministratorCompaniesForm"
            style={{ height: "100%", background: !this.is_new ? "white" : "" }}>
            <div
              className="AdministratorCompaniesForm-header"
              style={!this.is_new ? { border: "0", paddingBottom: 0 } : {}}>
              <div className="AdministratorCompaniesForm-header-title">
                <Link
                  className="AdministratorCompaniesForm-header-title-link"
                  to="/companies/">
                  <LeftOutlined /> Empresas
                </Link>
                <span>{this.is_new ? "Crear empresa" : "Editar empresa"}</span>
              </div>
              {!this.is_new && !this.checkLoading() && (
                <div className="AdministratorCompaniesForm-header-buttons">
                  {this.renderDisableCompanySwitch()}
                  {!this.props.current_company.visma_people_sync_enabled && (
                    <Dropdown
                      overlay={
                        <Menu
                          style={{
                            display: formData.disabled ? "none" : "block",
                          }}>
                          <Menu.Item
                            disabled={delete_loading}
                            onClick={() =>
                              this.setState({ modalCompanyDelete: true })
                            }
                            className="color-red"
                            key="1">
                            Eliminar empresa
                          </Menu.Item>
                        </Menu>
                      }>
                      <EllipsisOutlined
                        type="ellipsis"
                        style={{
                          color: "#378FEE",
                          fontSize: "26px",
                          cursor: "pointer",
                        }}
                      />
                    </Dropdown>
                  )}
                </div>
              )}
            </div>
            {!this.is_new && (
              <Tabs
                animated={false}
                defaultActiveKey="1"
                onChange={(e) =>
                  this.setState({ tab: parseInt(e, 10) }, () => {
                    if (!isEqual(compareData, compareDataBackup)) {
                      this.props.form.validateFieldsAndScroll()
                    }
                  })
                }>
                <TabPane tab="Información" key="1" />
                <TabPane tab="Administradores" key="3" />
              </Tabs>
            )}
            <div
              className="AdministratorCompaniesForm-body"
              style={!this.is_new ? { paddingTop: "0.5rem" } : {}}>
              <div
                className="AdministratorCompaniesForm-body-content"
                style={!this.is_new ? { border: "0", padding: 0 } : {}}>
                {this.checkLoading() ? (
                  <div className="loadingSpin">
                    <Spin size="large" />
                  </div>
                ) : (
                  this.renderTab()
                )}
              </div>
            </div>
          </div>
          {((!this.checkLoading() && this.is_new && tab == "1") ||
            (!isEqual(compareData, compareDataBackup) && tab == "1")) && (
            <ButtonsFooter
              buttons={[
                {
                  content: "Cancelar",
                  onClick: () => this.props.history.push("/companies"),
                  type: "",
                },
                {
                  content: this.is_new ? "Crear" : "Guardar",
                  onClick: this.handleSave,
                  type: "primary",
                  loading: save_loading,
                  disabled: this.checkIfSaveButtonIsDisabled()
                },
              ]}
            />
          )}
        </div>

        <ModalCreateUser
          updateInfoUserWatcher={() => {}}
          disabledRol={
            users.filter((e) => e.isCompanySuperAdmin).length === 1 &&
            userSelected.isCompanySuperAdmin
          }
          company_id={companyId}
          getUsers={() => this.props.usersCompany({ company_id: companyId })}
          userSelected={userSelected}
          visible={modalCreateUser}
          title={modalAdminTitle}
          setStateFrom={this.setStateFrom}
        />
        <ModalCustom
          modalOpen={!this.is_new && modalChangeLicense}
          onCancel={() => this.setState({ modalChangeLicense: false })}
          showFooter
          onOk={this.pressSave}>
          <img src={alertSvg} className="alertIcon" />
          <span style={{ fontWeight: 600, fontSize: 14 }}>
            ¿Estás seguro de que deseas cambiar de licencia?
          </span>
          <span style={{ fontSize: 14, lineHeight: "19px", margin: "12px 0" }}>
            Las consecuencias séran las siguientes:
          </span>
          <ul
            style={{ margin: "0 42px", textAlign: "start", fontSize: "14px" }}>
            <li>
              Los <strong>usuarios embajadores</strong> y/o{" "}
              <strong>líderes</strong> que se tengan creados se{" "}
              <span style={{ fontWeight: "bold", textDecoration: "underline" }}>
                eliminarán
              </span>{" "}
              del sistema de inmediato.
            </li>
            <li>
              Los <strong>planes de acción</strong> que se tengan creados
              permanecerán guardados durante <strong>30 días</strong>. Luego de
              ese periodo, procederán a{" "}
              <span style={{ fontWeight: "bold", textDecoration: "underline" }}>
                eliminarse
              </span>{" "}
              del sistema.
            </li>
          </ul>
        </ModalCustom>
        <ModalCustom
          onCancel={() => {
            this.setState({ modalEnableVismaPeopleSync: false })
            this.setFormData("visma_people_sync_request", false)
         
          }}
          onOk={() => {
            this.setState({ modalEnableVismaPeopleSync: false })
            this.setFormData("visma_people_sync_request", true)
            try {
              const response = toggleSyncSwitch();
            } catch (error) {
              console.error('Error:', error);
            }
          }}
          modalOpen={this.state.modalEnableVismaPeopleSync}
          showFooter
          colorButton="#E37879"
          textButton="Continuar">
          <div className="component-deletesimple">
            <img src={alertSvg} className="alertIcon" />
            <div className="component-deletesimple__description">
              <b>
                ¿Estás seguro de que deseas integrar esta empresa con Visma People?
              </b>
              <br />
              <br />
              <p>
                Activar este switch es el <b>primer paso para sincronizar</b> la información de los colaboradores de Visma People en Visma Mandü. 
                Después, <b>será necesario registrar un ticket</b> de soporte para completar el proceso.
              </p>
            </div>
          </div>
        </ModalCustom>

        <ModalCustom
          onCancel={() => {
            this.setState({ modalDisableVismaPeopleSync: false })
            this.setFormData("visma_people_sync_request", true)
          }}
          onOk={() => {
            this.props.resetVismaPeopleValidations()
            this.setState({ modalDisableVismaPeopleSync: false })
            this.setFormData("visma_people_sync_request", false)
          }}
          modalOpen={this.state.modalDisableVismaPeopleSync}
          showFooter
          colorButton="#E37879"
          textButton="Continuar">
          <div className="component-deletesimple">
            <img src={alertSvg} className="alertIcon" />
            <div className="component-deletesimple__description">
              <b>
                ¿Estás seguro de que deseas desincronizar esta empresa con Visma People?
              </b>
              <br />
              <br />
              <p>
                Desactivar este switch es el <b>primer paso para anular la sincronización</b> de la información de los colaboradores de Visma People en Visma Mandü. 
                Después, <b>será necesario registrar un ticket</b> de soporte para completar el proceso.
              </p><br/>
              <p>
                Una vez completado el proceso, <b>la información almacenada hasta el momento</b> en Visma Mandü <b>será conservada</b>.
              </p>
            </div>
          </div>
        </ModalCustom>



        <ModalCustom
          onCancel={() => this.setState({ modalSwitchCompany: false })}
          onOk={() => {
            this.props.statusCompany({ company_id: companyId, active: false })
            this.setState({ modalSwitchCompany: false })
            this.setFormData("active", false)
          }}
          modalOpen={modalSwitchCompany}
          showFooter
          textButton="Continuar">
          <div className="component-deletesimple">
            <img src={alertSvg} className="alertIcon" />
            <div className="component-deletesimple__description">
              <b>
                ¿Estás seguro de que deseas apagar la empresa {formData.name}?{" "}
              </b>
              <br />
              <br />
              <p>
                Esto bloqueará el ingreso a la plataforma por parte del cliente
                hasta que la acción sea revertida.
              </p>
            </div>
          </div>
        </ModalCustom>
        <ModalDeleteSimple
          visible={modalAdminDelete}
          content={
            <p>
              ¿Estás seguro de que deseas eliminar a{" "}
              <span>{`${userSelected.first_name} ${userSelected.last_name}`}</span>{" "}
              como{" "}
              {userSelected.id_role == ROLE_COMPANY_SUPER_ADMIN
                ? "superadministrador"
                : "administrador"}
              .
            </p>
          }
          onOk={() => {
            let validationAdmin = users.filter(
              (u) => u.isCompanySuperAdmin === true && u.id != userSelected.id
            )
            if (
              validationAdmin.length == 0 &&
              userSelected.isCompanySuperAdmin
            ) {
              message.error(
                "No es posible eliminar a todos los usuarios superadministradores.",
                5
              )
            } else {
              this.props.deleteUser({
                company_id: companyId,
                user_id: userSelected.id,
              })
              this.setState({ modalAdminDelete: false }, () =>
                this.setState({ userSelected: {} })
              )
            }
          }}
          onCancel={() => {
            this.setState({ modalAdminDelete: false })
          }}
        />
        <ModalDeleteSimple
          visible={modalCompanyDelete}
          content={
            <div style={{ textAlign: "center" }}>
              <b>
                ¿Estás seguro de que deseas eliminar la empresa{" "}
                {`${formData.name}`}?
              </b>
              <br />
              <br />
              <p>
                Esto borrará{" "}
                <b>
                  <u>permanentemente</u>
                </b>{" "}
                toda la información que haya sido creada, y se bloqueará el
                acceso a la plataforma.{" "}
              </p>
            </div>
          }
          loading={delete_loading}
          onOk={() => {
            this.props.deleteCompany({ company_id: this.state.companyId })
            // this.setState({ modalCompanyDelete: false })
          }}
          onCancel={() => {
            this.setState({ modalCompanyDelete: false })
          }}
        />
      </Layout>
    )
  }
}

Form.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  options: makeSelectOptions(),
  options_loading: makeSelectOptionsLoading(),
  save_loading: makeSelectSaveLoading(),
  current_company: makeSelectCurrentCompany(),
  current_company_loading: makeSelectCurrentCompanyLoading(),
  current_users_loading: makeSelectCurrentUsers(),
  delete_loading: makeSelectDeleteLoading(),
  users_loading: makeSelectUsersLoading(),
  users: makeSelectUsers(),
  loading_switcher_admin: makeSelectUserSASwitch(),
  validateVismaPeopleInfoRequested: makeSelectValidateVismaPeopleInfoRequested(),
  validateVismaPeopleInfoLoading: makeSelectValidateVismaPeopleInfoLoading(),
  validateVismaPeopleInfo: makeSelectValidateVismaPeopleInfo(),
  validateVismaPeopleStructureRequested: makeSelectValidateVismaPeopleStructureRequested(),
  validateVismaPeopleStructureLoading: makeSelectValidateVismaPeopleStructureLoading(),
  validateVismaPeopleStructure: makeSelectValidateVismaPeopleStructure(),
  validateVismaPeopleStructureFeedback: makeSelectValidateVismaPeopleStructureFeedback()
})

function mapDispatchToProps(dispatch) {
  return {
    getCompaniesInfo: (params) => dispatch(getCompaniesInfoWatcher(params)),
    saveCompany: (params) => dispatch(saveCompanyWatcher(params)),
    getCompany: (params) => dispatch(getCompanyWatcher(params)),
    getUsers: (params) => dispatch(getCompanyUsersWatcher(params)),
    deleteCompany: (params) => dispatch(deleteCompanyWatcher(params)),
    statusCompany: (params) => dispatch(statusCompanyWatcher(params)),
    usersCompany: (params) => dispatch(usersCompanyWatcher(params)),
    usersSASwitch: (params) => dispatch(usersSASwitchWatcher(params)),
    deleteUser: (params) => dispatch(deleteUserWatcher(params)),
    validateVismaPeopleInfoWatcher: (params) =>  dispatch(validateVismaPeopleInfoWatcher(params)),
    validateVismaPeopleStructureWatcher: (params) =>  dispatch(validateVismaPeopleStructureWatcher(params)),
    updateValidateVismaPeopleRequested: (params) => dispatch(updateValidateVismaPeopleRequested(params)),
    updateValidateVismaPeopleStructureRequested: (params) => dispatch(updateValidateVismaPeopleStructureRequested(params)),
    resetCompaniesInfo: () => dispatch(resetCompaniesInfo()),
    resetVismaPeopleValidations: () => dispatch(resetVismaPeopleValidations()),
    resetVismaPeopleStructureValidations: () => dispatch(resetVismaPeopleStructureValidations())
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({
  key: "AdministratorCompaniesForm",
  reducer,
})
const withSaga = injectSaga({ key: "AdministratorCompaniesForm", saga })

const ExportFormCompany = Form.create({ name: "mandu_form_company" })(
  FormCompany
)

export default compose(withReducer, withSaga, withConnect)(ExportFormCompany)
